export default {"src":"/_next/static/media/gold.4c7fbab6.svg","height":81,"width":153};